import { PlatformSource } from '@byted-star/enums';
import type {
  InterfaceNormalList,
  InterfacePlatformSource,
  InterfaceTab,
  InterfaceUser,
} from './Interface';
import { SwitchType, PanelType } from './enums';

export default {
  id: 'login-sdk',
  // bootstrap: true,
  // 星图登录 ID
  appId: 2554,
  isBoe: false,
  // 主标题
  title: ' ',
  className: 'star-login-container',
  // 主题色
  themeColor: '#FE346E',
  // 设置注册功能面板
  register: {
    show: false,
  },
  // 星图 creator 即合creative
  site: 'creator',
  // dom 渲染排序 0 agreement 1 message 2 submit 3 switch row   4 oauth
  orders: [0, 1, 2, 3, 4], // 数组下标代表 左边真实渲染顺序，值代表右边的从协议开始的dom
  // showOauthTypes: ['douyin', 'ixigua', 'toutiao', 'huoshan'],
  // 面板切换
  switchConfig: {
    defaultSwitch: SwitchType.mobile,
    switch: {
      mobile: {
        show: false,
      },
      email: {
        show: false,
      },
      code: {
        show: false,
      },
    },
    defaultPanel: PanelType.login,
    panel: {
      login: {
        show: false,
        form: {
          // 邮箱
          email: {
            formatErrorTxt: '邮箱格式不正确',
          }, 
          // 邮箱密码
          password: {
            pattern: '^(.*).{6,20}$',
            fieldName: '密码',
            required: '密码必须包括数字,大小写英文字母，长度6-20位',
            min: 6,
            max: 20,
            formatErrorTxt: '密码必须包括数字,大小写英文字母，长度6-20位',
          },
        },
      },
      register: {
        show: false,
      },
      forgetPwd: {
        show: false,
      },
    },
  },
  ssoConfigs: {
    openSSO: true,
    common: {
      // 服务协议
      protocol_url: '/protocol?id=20210530',
      // 隐私协议
      privacy_url: '/protocol?id=20210529&enable_title=1',
    },
    register: {
      callback_url: '',
    },
    login: {
      callback_url: '',
    },
    forgetPwd: {
      callback_url: '',
    },
  },
  switchCallback: null,
  // 第三方登录配置
  oauthConfig: {
    // 授权过程中是否允许取消
    allowCancel: true,
    // appid 维度的第三方授权绑定关系，云平台配置
    // douyin: {
    //   link:
    //     'https://e.oceanengine.com/account/page/service/login?oauth=douyin&sso=1&appKey=3&from=https://www.xingtu.cn/ad',
    // },
    // 取消授权按钮的cb
    cancelCallBack: null,
    // 渲染出授权页面完成的回调,
    didMountCb: null,
    stateExtraCallback: null,
  },
};

/**
 * OauthConfigLink 跳转巨量引擎配置
 * 达人抖音回调链接   
 * https://www.xingtu.cn/login?is_new_connect=0&is_new_user=0&login_source=1&login_type=sup_douyin&oauth_callback=author&role=sup&site=creator
 * login_source 登录平台 1 pc   login_type 登录的媒体端类型 sup_douyin   oauth_callback author  回调函数
 */
export const OauthConfigLink = {
  boe: {
    protocol: 'https',
    host: 'e-boe.oceanengine.com',
    login: {
      pathname: '/account/page/service/login',
      query: {
        oauth: 'douyin',
        sso: 1,
        appKey: '3',
      },
      callback: {
        ad: 'https://www-boe.xingtu.cn/login',
        sup: 'https://www-boe.xingtu.cn/pre-check',
        // mcn 需要单独校验，所以需要跳转回来再做校验 platform_source login_source
        mcn: 'https://www-boe.xingtu.cn/v/api/mcn/oceanengine_callback/',
        // 优选服务商
        preferFacilitator: 'https://www-boe.xingtu.cn/facilitator/user/prefer-plan',
      },
    },
    register: {
      pathname: '/account/page/service/register',
      query: {
        oauth: 'douyin',
        sso: 1,
        appKey: '3',
      },
      callback: {
        ad: 'https://www-boe.xingtu.cn/login',
        sup: 'https://www-boe.xingtu.cn/pre-check',
        // mcn 需要单独校验，所以需要跳转回来再做校验 platform_source login_source
        mcn: 'https://www-boe.xingtu.cn/v/api/mcn/oceanengine_callback/',
        // 优选服务商
        preferFacilitator: 'https://www-boe.xingtu.cn/facilitator/user/prefer-plan',
      },
    },
    forgetPwd: {},
  },
  production: {
    protocol: 'https',
    host: 'e.oceanengine.com',
    login: {
      pathname: '/account/page/service/login',
      query: {
        oauth: 'douyin',
        sso: 1,
        appKey: '3',
      },
      callback: {
        ad: 'https://www.xingtu.cn/login',
        sup: 'https://www.xingtu.cn/pre-check',
        // mcn 需要单独校验，所以需要跳转回来再做校验 platform_source login_source
        mcn: 'https://www.xingtu.cn/v/api/mcn/oceanengine_callback/',
        // 优选服务商
        preferFacilitator: 'https://www.xingtu.cn/facilitator/user/prefer-plan',
      },
    },
    register: {
      pathname: '/account/page/service/register',
      query: {
        oauth: 'douyin',
        sso: 1,
        appKey: '3',
      },
      callback: {
        ad: 'https://www.xingtu.cn/login',
        sup: 'https://www.xingtu.cn/pre-check',
        // mcn 需要单独校验，所以需要跳转回来再做校验 platform_source login_source
        mcn: 'https://www.xingtu.cn/v/api/mcn/oceanengine_callback/',
        // 优选服务商
        preferFacilitator: 'https://www.xingtu.cn/facilitator/user/prefer-plan',
      },
    },
    forgetPwd: {},
  },
};
// https://www.xingtu.cn/mcn/?platform_source=2&login_source=1

/** 第三方登录名称配置 */
export const OauthList: InterfacePlatformSource[] = PlatformSource.metas();

/**
 * UserRole 用户角色配置描述
 * @key role ad,sup,mcn
 * @key name 广告主,达人,mcn 机构
 * @key value 1,2,3
 */
export const UserRole: InterfaceUser[] = [
  {
    name: '广告主',
    value: 1,
    role: 'ad',
    mobile: {
      login: {
        show: true,
      },
      register: {
        show: true,
      },
    },
    email: {
      login: {
        show: true,
        panel: {
          register: {
            show: true,
          },
          forgetPwd: {
            show: true,
          },
        },
      },
      register: {
        show: true,
        panel: {
          login: {
            show: true,
          },
          forgetPwd: {
            show: false,
          },
        },
      },
      forgetPwd: {
        show: true,
      },
    },
  },
  {
    name: '达人',
    value: 2,
    role: 'sup',
    mobile: {
      login: {
        show: true,
      },
      register: {
        show: true,
      },
    },
    email: {
      login: {
        show: true,
        panel: {
          register: {
            show: true,
          },
          forgetPwd: {
            show: true,
          },
        },
      },
      register: {
        show: true,
        panel: {
          login: {
            show: true,
          },
          forgetPwd: {
            show: false,
          },
        },
      },
      forgetPwd: {
        show: true,
      },
    },
  },
  {
    name: 'MCN',
    value: 3,
    role: 'mcn',
    mobile: {
      login: {
        show: true,
        oauthList: ['douyin', 'toutiao'],
      },
    },
    email: {
      login: {
        show: true,
        panel: {
          forgetPwd: {
            show: true,
          },
        },
        oauthList: ['douyin', 'toutiao'],
      },
      forgetPwd: {
        show: true,
      },
    },
  },
  {
    name: '优选服务商',
    value: 7,
    role: 'preferFacilitator',
    mobile: {
      login: {
        show: true,
      },
      register: {
        show: true,
      },
    },
    email: {
      login: {
        show: true,
        panel: {
          forgetPwd: {
            show: true,
          },
        },
      },
      forgetPwd: {
        show: true,
      },
    },
  }
];

// 登录切换选项
export const loginTabs: InterfaceTab[] = [
  {
    key: '手机登录',
    value: 1,
    include: [SwitchType.mobile, PanelType.login],
    formValid: ['mobile', 'mobilecaptcha'],
  },
  {
    key: '手机登录',
    value: 2,
    include: [SwitchType.mobile, PanelType.register],
    formValid: ['mobile', 'mobilecaptcha'],
  },
  {
    key: '邮箱登录',
    value: 3,
    include: [SwitchType.email, PanelType.login],
    formValid: ['email', 'password'],
  },
  {
    key: '邮箱注册',
    value: 4,
    include: [SwitchType.email, PanelType.register],
    formValid: ['email', 'emailcaptcha', 'password', 'repeatPwd'],
  },
  {
    key: '修改密码',
    value: 5,
    include: [SwitchType.email, PanelType.forgetPwd],
    formValid: ['email', 'emailcaptcha', 'password', 'repeatPwd'],
  },
];

// 弹框类型 panel
export const panelList: InterfaceNormalList[] = [
  {
    key: '登录',
    value: PanelType.login,
  },
  {
    key: '注册',
    value: PanelType.register,
  },
  {
    key: '忘记密码',
    value: PanelType.forgetPwd,
  },
];

// 弹框种类 switchType
export const switchTypeList: InterfaceNormalList[] = [
  {
    key: '手机',
    value: SwitchType.mobile,
  },
  {
    key: '邮箱',
    value: SwitchType.email,
  },
];
